import React, { useState } from "react";
import { OverviewMapPanel } from "components/OverviewPages/Map/OverviewMapPanel";
import { MachinesDownKpi } from "components/OverviewPages/KPIs/MachinesDownKpi";
import { FleetCaseMeanResponseTimeKpi } from "components/OverviewPages/KPIs/CaseMeanTimeKpi";
import { FleetCaseSummaryKpi } from "components/OverviewPages/KPIs/CaseSummaryKpi";
import { FleetSavingsKpi } from "components/OverviewPages/KPIs/SavingsKpi";
import { useGetFleetPageData } from "hooks/useGetFleetPageData";
import { useTrackPageView } from "hooks/useTrackPageView";
import { FleetTable } from "components/OverviewPages/FleetTable";
import Paper from "@mui/material/Paper";
import Skeleton from "@mui/material/Skeleton";
import useDumbPageTitle from "hooks/useDumbPageTitle";
import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Grid";

const PAGE_TITLE = "Fleet";

export const FleetPage = () => {
  useDumbPageTitle(PAGE_TITLE);
  useTrackPageView(PAGE_TITLE);

  const { loading, error, data } = useGetFleetPageData();
  const [selectedSite, setSelectedSite] = useState(null);

  const enableSelectedSite = site_id => {
    setSelectedSite(site_id);
  };

  // Remap data for map component
  const mappedMapValues =
    data.newSites?.map(result => {
      return {
        latitude: result?.bounds?.center_latitude,
        longitude: result?.bounds?.center_longitude,
        name: result?.site,
        isMarkerSelected: (marker, selectedMarker) =>
          marker && selectedMarker && marker === selectedMarker,
        marker: result?.site
      };
    }) ?? [];

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6} lg={3}>
        <MachinesDownKpi expanded fleet />
      </Grid>
      <Grid item xs={12} sm={6} lg={3}>
        <FleetCaseMeanResponseTimeKpi expanded fleet />
      </Grid>
      <Grid item xs={12} sm={6} lg={3}>
        <FleetCaseSummaryKpi expanded fleet />
      </Grid>
      <Grid item xs={12} sm={6} lg={3}>
        <FleetSavingsKpi expanded fleet />
      </Grid>
      <Grid item xs={12} md={8}>
        <TableContainer elevation={0}>
          {loading && !error ? (
            <FleetTableSkeletonWrapper>
              <FleetTableSkeleton />
            </FleetTableSkeletonWrapper>
          ) : (
            <FleetTable
              fleetTableData={data.newSites ?? []}
              enableSelectedSite={enableSelectedSite}
              selectedSiteName={selectedSite}
              loading={loading}
            />
          )}
        </TableContainer>
      </Grid>
      <Grid item xs={12} md={4}>
        {loading ? (
          <FleetMapSkeletonWrapper>
            <FleetMapSkeleton />
          </FleetMapSkeletonWrapper>
        ) : (
          <OverviewMapPanel
            data={mappedMapValues}
            selectedMarker={selectedSite}
            onChangeMarker={enableSelectedSite}
          />
        )}
      </Grid>
    </Grid>
  );
};

const TableContainer = styled(Paper)`
  display: flex;
  flex-direction: column;
  height: calc(100vh - 8rem - 123px);
`;

const FleetTableSkeletonWrapper = styled("div")`
  display: flex;
  justify-content: center;
  height: 100%;
`;

const FleetTableSkeleton = styled(Skeleton)`
  transform: none;
  height: 50%;
  width: 97%;
  margin-top: 15px;
`;

const FleetMapSkeletonWrapper = styled("div")`
  height: 100%;
`;

const FleetMapSkeleton = styled(Skeleton)`
  transform: none;
  height: 100%;
`;
